var Audio = require('../lib/audio');
var CommonAnimations = require('./common');

var audios = {
    slotCrank: new Audio('/audio/arm-pull-v1-v2.mp3', { channel: 'frame' }),
    rotate: new Audio('/audio/rotate-dry.mp3', { channel: 'frame' }),
    filling: new Audio('/audio/28nov/oligarchie-cuve-remplissage-03.mp3', { channel: 'frame' })
};

module.exports = {

    getFunnelTrioTimeline: function(sprites, currentTrioState, opts)
    {
        opts = _.extend({
            pixiFlux: null,
            intensity: 1,
            minIntensity: 1,
            maxIntensity: 1,
            trioPersons: [],
            solo: false
        }, opts);

        var funnelPixiFlux = opts.pixiFlux;
        var trioPersons = opts.trioPersons;
        var minIntensity = opts.minIntensity;
        var maxIntensity = opts.maxIntensity;

        var timeline = new TimelineMax();

        var i, il, j, jl,
            spriteKey, objectKey;

        // left animations
        var leftAnimationsOpts = {
            fps: 9,
            repeat: 1,
            yoyo: true,
            onFrameUpdate: _.bind(function(movieclip){
                this.onTrioLeftFrameUpdate(movieclip, funnelPixiFlux);
            }, this)
        };

        for (i = minIntensity; i <= maxIntensity; i++)
        {
            for (j = 0, jl = trioPersons.length; j < jl; j++)
            {
                spriteKey = trioPersons[j]+'Left'+i;
                objectKey = trioPersons[j]+i;
                currentTrioState.leftAnimations[objectKey] = CommonAnimations.getMovieclipTimeline(sprites[spriteKey], leftAnimationsOpts);
                currentTrioState.leftAnimations[objectKey].pause();
            }
        }

        if (!opts.solo)
        {
            var animationOpts = {
                repeatDelay: 4
            };

            currentTrioState.rightAnimations = {
                baldGuy: CommonAnimations.getMovieclipTimeline(sprites.baldGuyRight, animationOpts),
                charles: CommonAnimations.getMovieclipTimeline(sprites.charlesRight, animationOpts),
                girl: CommonAnimations.getMovieclipTimeline(sprites.girlRight, animationOpts)
            };
            // right animations
            timeline.add(currentTrioState.rightAnimations.baldGuy, 0);
            timeline.add(currentTrioState.rightAnimations.charles, 0);
            timeline.add(currentTrioState.rightAnimations.girl, 0);

            currentTrioState.rightAnimations.baldGuy.pause();
            currentTrioState.rightAnimations.charles.pause();
            currentTrioState.rightAnimations.girl.pause();

            // rotation animations
            var rotationAnimationsOpts = {
                fps: 5,
                repeat: 0
            };
            for (i = 0, il = trioPersons.length; i < il; i++)
            {
                spriteKey = trioPersons[i]+'Rotation';
                objectKey = trioPersons[i];
                currentTrioState.rotationAnimations[objectKey] = CommonAnimations.getMovieclipTimeline(sprites[spriteKey], rotationAnimationsOpts);
                currentTrioState.rotationAnimations[objectKey].pause();
            }
        }

        this.updateTrio(sprites, opts.intensity, currentTrioState, {
            solo: opts.solo
        });

        return timeline;
    },

    onTrioLeftFrameUpdate: function(movieclip, funnelPixiFlux)
    {
        var currentFrame = movieclip.currentFrame;
        var lastFrame = movieclip.totalFrames - 1;
        var leverDown = currentFrame === lastFrame;
        if (leverDown)
        {
            var movingWalls = funnelPixiFlux.getMovingWalls();
            _.each(movingWalls, function(movingWall){
                if (movingWall.name === 'funnelHolder')
                {
                    movingWall.timeline.play();
                }
            });
            audios.filling.play({
                time: 0
            });
        }
    },

    updateFunnelTrioIntensity: function(width, height, sprites, intensity, currentTrioState, opts)
    {
        opts = _.extend({
            animationDuration: 0.6,
            onAnimationComplete: null,
            solo: false
        }, opts);

        if (opts.solo)
        {
            this.updateTrio(sprites, intensity, currentTrioState, {
                solo: opts.solo
            });
            this.initTrioLeftCrank(currentTrioState.leftAnimation);
            return;
        }

        var movementWidth = width * 0.08;

        var rightKey;
        var leftKey;
        var middleKey;

        switch (currentTrioState.pos)
        {
            case 0:
                leftKey = 'baldGuy';
                middleKey = 'charles';
                rightKey = 'girl';
            break;
            case 1:
                leftKey = 'girl';
                middleKey = 'baldGuy';
                rightKey = 'charles';
            break;
            case 2:
                leftKey = 'charles';
                middleKey = 'girl';
                rightKey = 'baldGuy';
            break;
        }

        var middleMiddleAnimationMovieclip = sprites[middleKey+'Middle'];
        middleMiddleAnimationMovieclip.gotoAndStop(2);

        var middleLeftAnimationMovieclip = sprites[leftKey+'Middle'];
        middleLeftAnimationMovieclip.visible = true;
        middleLeftAnimationMovieclip.gotoAndStop(1);

        var rightAnimationMovieclip = sprites[rightKey+'Rotation'];
        rightAnimationMovieclip.visible = true;

        sprites.trioLeft.visible = false;

        var timeline = new TimelineMax({
            onStart: function()
            {
                if (audios.rotate) {
                    audios.rotate.play();
                }

            },
            onComplete: () =>
            {
                if (middleLeftAnimationMovieclip && middleMiddleAnimationMovieclip) {
                    middleLeftAnimationMovieclip.x -= movementWidth;
                    middleMiddleAnimationMovieclip.x -= movementWidth;
                    rightAnimationMovieclip.visible = false;
                    sprites.trioLeft.visible = true;
                    sprites.baldGuyMiddle.gotoAndStop(0);
                    sprites.charlesMiddle.gotoAndStop(0);
                    sprites.girlMiddle.gotoAndStop(0);
                    this.updateTrio(sprites, intensity, currentTrioState);
                    this.initTrioLeftCrank(currentTrioState.leftAnimation);

                    if (_.isFunction(opts.onAnimationComplete)) {
                        opts.onAnimationComplete();
                    }
                }
            },
        });

        // rotation (left to middle + middle to right)
        timeline.fromTo(middleLeftAnimationMovieclip, opts.animationDuration, {
            x: middleLeftAnimationMovieclip.userData.initialPosition.x - movementWidth
        },{
            ease: Quad.easeInOut,
            x: middleLeftAnimationMovieclip.userData.initialPosition.x + movementWidth
        }, 0);

        timeline.fromTo(middleMiddleAnimationMovieclip, opts.animationDuration, {
            x: middleMiddleAnimationMovieclip.userData.initialPosition.x - movementWidth
        },{
            ease: Quad.easeInOut,
            x: middleMiddleAnimationMovieclip.userData.initialPosition.x + movementWidth
        }, 0);

        // rotation (right to left)
        currentTrioState.sprites.right.visible = false;
        timeline.fromTo(currentTrioState.rotationAnimations[rightKey], opts.animationDuration, {
            progress: 0
        },{
            ease: Linear.easeNone,
            progress: 1
        }, 0);
        timeline.to(rightAnimationMovieclip, opts.animationDuration / 2, {
            repeat: 1,
            yoyo: true,
            ease: Quad.easeInOut,
            y: rightAnimationMovieclip.userData.initialPosition.y + height * 0.01
        }, 0);
    },

    initTrioLeftCrank: function(leftAnimation)
    {
        leftAnimation.progress(0);
        leftAnimation.play();

        TweenMax.delayedCall(0.15, function(){
            audios.slotCrank.play();
        });
    },

    updateTrio: function(sprites, intensity, currentTrioState, opts)
    {
        opts = _.extend({
            solo: false
        }, opts);

        if (!opts.solo)
        {
            currentTrioState.pos = 0;
            // currentTrioState.pos++;
            // if (currentTrioState.pos === 1) {
            //     currentTrioState.pos = 2;
            // }else {
            //     currentTrioState.pos = 0;
            // }
        } else {
            currentTrioState.pos = 0;
        }

        if (currentTrioState.sprites)
        {
            currentTrioState.sprites.left.visible = false;
            if (!opts.solo)
            {
                currentTrioState.sprites.middle.visible = currentTrioState.sprites.right.visible = false;
            }
        }
        currentTrioState.sprites = {};

        // console.log(currentTrioState.pos);

        switch (currentTrioState.pos)
        {
            case 0:
                currentTrioState.sprites = {
                    left: _.get(sprites, 'baldGuyLeft'+intensity),
                    middle: sprites.charlesMiddle,
                    right: sprites.girlRight
                };
                currentTrioState.leftAnimation = _.get(currentTrioState.leftAnimations, 'baldGuy'+intensity);
                currentTrioState.rightAnimation = _.get(currentTrioState.rightAnimations, 'girl');
            break;
            case 1:
                currentTrioState.sprites = {
                    left: _.get(sprites, 'girlLeft'+intensity),
                    middle: sprites.baldGuyMiddle,
                    right: sprites.charlesRight
                };
                currentTrioState.leftAnimation = _.get(currentTrioState.leftAnimations, 'girl'+intensity);
                currentTrioState.rightAnimation = _.get(currentTrioState.rightAnimations, 'charles');
            break;
            case 2:
                currentTrioState.sprites = {
                    left: _.get(sprites, 'charlesLeft'+intensity),
                    middle: sprites.girlMiddle,
                    right: sprites.baldGuyRight
                };
                currentTrioState.leftAnimation =_.get(currentTrioState.leftAnimations, 'charles'+intensity);
                currentTrioState.rightAnimation = _.get(currentTrioState.rightAnimations, 'baldGuy');
            break;
        }
        currentTrioState.sprites.left.visible = true;
        if (!opts.solo)
        {
            currentTrioState.rightAnimation.play(0);
            currentTrioState.rightAnimation.timeScale(1 + (intensity-2) * 0.15);
            currentTrioState.sprites.middle.visible = currentTrioState.sprites.right.visible = true;
        }
    }
};



// WEBPACK FOOTER //
// ./js/animations/trioFunnel.js